import { motion } from 'framer-motion';
import React from 'react';
import ConnectivityBg from '../images/connectivity/background.jpg';
import RightBlock from '../images/connectivity/right-block.png';
import Footer from '../images/connectivity/footer.png';
import MagentaLine from './elements/MagentaLine';

export default function Connectivity() {
  const BASE_TIME = 2;
  const container = {
    /* ul animation */
    show: {
      transition: {
        delayChildren: BASE_TIME + 1.2,
        staggerChildren: 0.3,
      },
    },
  };
  const item = {
    /* li animation */
    hidden: { opacity: 0, x: -40 },
    show: { opacity: 1, x: 0, transition: { duration: 0.6 } },
  };

  return (
    <div id="connectivity-wrapper">
      <img src={ConnectivityBg} className="full-bg" />
      <header>
        <MagentaLine height="142px" left="40px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '25px',
              fontWeight: 'bold',
              top: '32px',
              left: '40px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Next-generation connectivity
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '23px',
              top: '64px',
              left: '40px',
              letterSpacing: '0.85px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            for smartphones
          </motion.div>
        </div>
      </header>

      <motion.div
        className="tagline"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME }}
      >
        Oticon More™ offers direct streaming from iPhone® and Android™ devices*
      </motion.div>
      <motion.ul variants={container} initial="hidden" animate="show">
        <motion.li variants={item}>
          Features Bluetooth® Low Energy technology and offers an extensive
          range of connectivity options to support a high-quality listening
          experience in everyday situations
        </motion.li>
        <motion.li variants={item}>
          Is a Made for iPhone hearing aid and compatible with the new Android
          protocol for Audio Streaming for Hearing Aids (ASHA) - making it
          possible to stream directly from iPhone, iPad®, iPod touch® and
          Android devices*
        </motion.li>
      </motion.ul>

      <motion.img
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 1.2 }}
        src={RightBlock}
        alt=""
        id="right-block"
      />
      <motion.img
        src={Footer}
        alt=""
        id="footer"
        initial={{ opacity: 0, y: 309 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 2.2 }}
      />
    </div>
  );
}
